import type {StockAvailability as StockAvailabilityData} from '../../../types';

type StockAvailabilityProps = {
  stockAvailability?: StockAvailabilityData;
};

const StockAvailability: React.FC<StockAvailabilityProps> = ({stockAvailability}) => {
  const available = stockAvailability?.available_count ?? 0;
  const outOfStock = stockAvailability?.out_of_stock_count ?? 0;
  const total = available + outOfStock;
  const availablePercentage = total > 0 ? (available / total) * 100 : 0;
  const outOfStockPercentage = total > 0 ? (outOfStock / total) * 100 : 0;

  return (
    <div className="flex flex-col gap-2.5 text-body-xs">
      <h3 className="my-2.5 text-body-xs text-neutral-fg">موجودی شما</h3>
      <div className="flex items-center gap-2.5">
        <span className="size-1.5 shrink-0 rounded-full bg-success" aria-hidden />
        <span className="w-20 shrink-0 text-body-xs-emphasis text-gray-07">موجود: {available}</span>
        <div
          className="h-3 flex-1 overflow-hidden rounded-full bg-gray-02"
          role="progressbar"
          aria-label="درصد کالاهای موجود"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(availablePercentage)}
        >
          <div
            className="h-full rounded-full bg-success"
            style={{width: `${availablePercentage}%`}}
          />
        </div>
      </div>
      <div className="flex items-center gap-2.5">
        <span className="size-1.5 shrink-0 rounded-full bg-destructive" aria-hidden />
        <span className="w-20 shrink-0 text-body-xs-emphasis text-gray-07">
          ناموجود: {outOfStock}
        </span>
        <div
          className="h-3 flex-1 overflow-hidden rounded-full bg-gray-02"
          role="progressbar"
          aria-label="درصد کالاهای ناموجود"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(outOfStockPercentage)}
        >
          <div
            className="h-full rounded-full bg-destructive"
            style={{width: `${outOfStockPercentage}%`}}
          />
        </div>
      </div>
    </div>
  );
};

export default StockAvailability;
